import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { OrderAttachmentResponse } from "../../orderAttachmentsApi";
import { addOrderAttachment, deleteOrderAttachment } from "../../orderAttachmentsApi";
import { useSnackbar } from "notistack";

export const useAttachments = (orderId: string) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const addAttachmentMutation = useMutation<OrderAttachmentResponse, unknown, { orderId: string; body: FormData }>({
    mutationFn: (m) => addOrderAttachment(m.orderId, m.body),
    onSuccess: async () => {
      enqueueSnackbar(`Załącznik został dodany`, { variant: "success" });
      await queryClient.invalidateQueries({ queryKey: ["orders", orderId] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się dodać załącznika. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  const deleteAttachmentMutation = useMutation<
    OrderAttachmentResponse[],
    unknown,
    { orderId: string; attachmentName: string }
  >({
    mutationFn: (m) => deleteOrderAttachment(m.orderId, m.attachmentName),
    onSuccess: async () => {
      enqueueSnackbar(`Załącznik został usunięty`, { variant: "success" });
      await queryClient.invalidateQueries({ queryKey: ["orders", orderId] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się usunąć załącznika. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return {
    addAttachment: (body: FormData) => addAttachmentMutation.mutateAsync({ orderId, body }),
    deleteAttachment: (attachmentName: string) => deleteAttachmentMutation.mutateAsync({ orderId, attachmentName }),
  };
};
